$(document).ready(function() {
  var algoliaContainer = $('.ais-Hits, .ais-InfiniteHits, .ais-hits');
  function disableEmptyPriceButtons() {
    $('.ais-hit--price').each(function() {
      var $priceElement = $(this);
      var $cartContainer = $priceElement.closest('.ais-hit--details').find('.ais-hit--cart');
      
      var priceText = $priceElement.text().trim();
      if (!priceText || priceText === 'null' || parseFloat(priceText.replace(/[^\d.]/g, '')) <= 0) {
        $cartContainer.addClass('atc-disabled');
        $cartContainer.find('.ais-hit--cart-button')
          .css({
            'pointer-events': 'none',
            'opacity': '0.5'
          })
          .prop('disabled', true);
      }
    });
  }
  disableEmptyPriceButtons();

  if (algoliaContainer.length) {
    var observer = new MutationObserver(disableEmptyPriceButtons);
    observer.observe(algoliaContainer[0], {
      childList: true,
      subtree: true
    });
  }

  var checkInterval = setInterval(disableEmptyPriceButtons, 1000);
  setTimeout(function() {
    clearInterval(checkInterval);
  }, 5000);
});



$('.custom-addon-products__row .heading').on('click', function() {
  const $row = $(this).closest('.custom-addon-products__row');
  $('.custom-addon-products__row .custom-addon-products')
    .not($row.find('.custom-addon-products'))
    .slideUp();
  $row.find('.custom-addon-products').slideToggle();
});

const productSelectors = document.querySelectorAll('.addon-products');

function undelCartadd() {
  let selectedProducts = [];
  productSelectors.forEach(function(selector) {
    const selectedOption = selector.options[selector.selectedIndex];
    const productId = selectedOption.value;
    if (productId) {
      selectedProducts.push({
        id: productId,
        quantity: inputValue
      });
    }
  });

  if (selectedProducts.length > 0) {
    addMultipleToCart(selectedProducts);
  }
}

function addMultipleToCart(products) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: products
    })
  });
}

document.querySelectorAll(".product-form--atc-button")?.forEach((addBTN) => {
  addBTN.addEventListener("click", undelCartadd);
});

let priceFloat = parseFloat(document.querySelector(".product-details .product-title-wrap .product-pricing .price--main .exl_vat.wrap_price .money_without_discount")?.textContent.replace(/[^0-9.]/g, '')) || 0;
let totalPrice;

productSelectors.forEach((selector) => {
  selector.addEventListener("change", () => {
    totalPrice = priceFloat;

    productSelectors.forEach((dropdown) => {
      const selectedOption = dropdown.options[dropdown.selectedIndex];
      const dataprice = selectedOption.getAttribute("dataprice");
      totalPrice += parseFloat(dataprice) / 100 || 0;
    });

    totalPrice = parseFloat(totalPrice.toFixed(2));

    document.querySelectorAll(".product-details .product-title-wrap .product-pricing .price--main .exl_vat.wrap_price .money_without_discount")?.forEach((price) => {
      price.textContent = totalPrice;
    });

    document.querySelectorAll(".product-details .product-title-wrap .product-pricing .price--main .inc_vat .money-with-discount")?.forEach((price) => {
      price.textContent = (totalPrice * 1.2).toFixed(2);
    });
  });
});